import Vue from 'vue'
import Router from 'vue-router'
import packageInfo from '../../package.json'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/' + packageInfo.name,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    { path: '/', name: 'Activity', component: () => import(/* webpackChunkName: "activity" */ '@/views/Activity/index.vue') },
    { path: '/rewards', name: 'Rewards', component: () => import(/* webpackChunkName: "rewards" */ '@/views/Rewards/index.vue') },
    { path: '/fallback', name: 'Fallback', component: () => import(/* webpackChunkName: "fallback" */ '@/views/Fallback/index.vue') }
  ]
})
